import { Stack } from '@mui/material'
import ToolPermissionsGroup from './ToolPermissionsGroup.jsx'

export default function ToolPermissionsGroups({ groups, onChange }) {
  return (
    <Stack spacing={1.25}>
      {groups.map((group) => <ToolPermissionsGroup key={group.id} group={group} onChange={onChange} />)}
    </Stack>
  )
}
